import React, {PureComponent} from 'react';
import $ from "jquery";
import ReactTooltip from "react-tooltip";
import {
    confirmIdentity,
    connectSocket,
    closeSocket,
    subscribeDashToServer,
    subscribeToStandingsInfo
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class PopoutLiveTimingMiniChallenge extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            categoryList: [],
            tableRows: [],
            zones: [],
            sessionDetails: {},
            carList: [],
            confirmedOrg: true,
        };

        this.makeTableRows = this.makeTableRows.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.getCarList = this.getCarList.bind(this);
        this.getSpeedControlTransitions = this.getSpeedControlTransitions.bind(this);
        this.compare = this.compare.bind(this);
    }

    /* LIFECYCLE */
    componentDidMount() {
        $('.loading').fadeIn();
        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, (confirmed) => {
            if (confirmed) {
                // Connect Socket
                connectSocket(this.props.cookies.get("authToken"), null, this.props.match.params.sessionID, this.props.match.params.eventID, "LIVETIMINGMINICHALLENGE", (msg) => {
                    console.log("[LIVE TIMING MINI]" + msg);
                    // DS
                    subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
                        console.log("DEDICATED STREAM SUBSCRIBED");
                    });
                    // Subscribe to standings info
                    subscribeToStandingsInfo(this.props.match.params.eventID, false, (err, standings) => {
                        if (this.state.sessionDetails.speed_control_zone_cnt >= 0) {
                            for (let st = 0; st < standings.std.length; st++) {
                                for (let car = 0; car < this.state.carList.length; car++) {
                                    if (this.state.carList[car].id === standings.std[st].cid) {
                                        if (this.state.carList[car].data) {
                                            let temp = this.state.carList.slice();
                                            temp[car].data["position"] = standings.std[st].position;
                                            temp[car].data["lap_cnt"] = standings.std[st].lap_cnt;
                                            this.setState({
                                                carList: temp,
                                            });
                                        }
                                        break;
                                    }
                                }
                            }
                            this.getSpeedControlTransitions();
                        }
                    });
                });

                this.getSessionDetails();
                this.getCarList();
                this.getSpeedControlTransitions();
            } else {
                this.setState({
                    confirmedOrg: false,
                });
            }
        });
    }

    componentWillUnmount() {
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[DASHBOARD] DEDICATED STREAM UNSUBSCRIBED");
        });
        subscribeToStandingsInfo(this.props.match.params.eventID, true, null);
        closeSocket();
    }

    /* GET DATA */
    getSessionDetails() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    sessionDetails: data,
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        }).done(function () {
            console.log("COMPLETE getSessionDetails");
        });
    }

    getCarList() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getCarList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
                teamID: helper.props.match.params.teamID,
                carIDs: null,
            },
            success: function (data) {
                helper.setState({
                    carList: data,
                }, () => {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].id === parseInt(helper.props.match.params.carID)) {
                            helper.setState({
                                currentLiveryID: data[i].livery_number,
                            });
                            break;
                        }
                    }

                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    carList: [{
                        id: 0,
                        livery_number: 0,
                        short_name: "---",
                        title: "---",
                        speedSource: "OBD",
                    }]
                });
            }
        }).done(function () {
            helper.getSpeedControlTransitions();
        });
    }

    getSpeedControlTransitions() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getCarZonesList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
                numSpeedTraps: helper.state.sessionDetails.speed_control_zone_cnt,
            },
            success: function (data) {
                for (let car = 0; car < helper.state.carList.length; car++) {
                    for (let zones = 0; zones < data.length; zones++) {
                        if (helper.state.carList[car].id === data[zones].car_id) {
                            helper.state.carList[car]["zones"] = data[zones].zones;
                            helper.state.carList[car]["data"] = data[zones].data;
                            helper.state.carList[car]["clean"] = data[zones].clean;
                            helper.state.carList[car]["over_limit"] = data[zones].over_limit;
                            break;
                        }
                    }
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        }).done(function () {
            helper.state.carList.sort(helper.compare);
            helper.makeTableRows();
        });
    }

    compare(a, b) {
        if (a.data.position === 0 || b.data.position === 0) {
            if (a.data.position === 0) {
                return 1;
            } else if (b.data.position === 0) {
                return -1;
            }
        } else if (a.data.position < b.data.position) {
            return -1;
        } else if (a.data.position > b.data.position) {
            return 1;
        }
    }

    /* RENDER */
    makeTableRows() {
        let rows = [];
        if (this.state.carList.length > 0 && this.state.carList[0].zones) {
            for (let car = 0; car < this.state.carList.length; car++) {
                let zones = [];
                // Iterate through known control zones
                let found;
                for (let speedTrap = 0; speedTrap < this.state.sessionDetails.speed_control_zone_cnt; speedTrap++) {
                    found = false;
                    for (let i = 0; i < this.state.carList[car].zones.length; i++) {
                        if (this.state.carList[car].zones[i].speed_control_zone_internal_order === speedTrap) {
                            found = true;
                            zones.push(
                                <td key={i}
                                    id={"split_cell"}
                                    data-tip={true}
                                    data-for={"zone_" + i + "_" + this.state.carList[car].zones[i].session_lap_id}
                                >
                                    <div style={{cursor: "pointer"}}>
                                        <span style={{
                                            display: "block",
                                            backgroundColor: this.state.carList[car].zones[i].is_clean_transition === 1 ? "#009e1a" : "#dd0008",
                                            color: "#FFFFFF",
                                        }}>
                                            {(this.state.carList[car].zones[i].is_clean_transition === 1 ? this.props.t("ok").toUpperCase() : this.props.t("overLimit").toUpperCase())}
                                        </span>
                                        <span className={"App_small_header"}>
                                            <strong style={{color: "#009e1a"}}>{this.state.carList[car].clean[speedTrap]}</strong> | <strong style={{color: "#ff1d00"}}>{this.state.carList[car].over_limit[speedTrap]}</strong>
                                        </span>
                                        <ReactTooltip id={"zone_" + i + "_" + this.state.carList[car].zones[i].session_lap_id} type={"light"}>
                                            {(this.state.carList[car].zones[i].is_clean_transition === 0 ? (
                                                <h2 style={{backgroundColor: "#d90020", color: "#FFFFFF"}}>{this.props.t("max").toUpperCase()}: {this.state.carList[car].zones[i].trigger_speed_if_not_clean_transition} km/h</h2>
                                            ) : (
                                                <h2 style={{backgroundColor: "#008607", color: "#FFFFFF"}}>{this.props.t("max").toUpperCase()}: {this.state.carList[car].zones[i].trigger_speed_if_not_clean_transition} km/h</h2>
                                            ))}
                                            <p className={"App_header"} style={{color: "#000000"}}>
                                                {this.props.t("entry")}: <strong style={{fontSize: 26, color: (this.state.carList[car].zones[i].is_clean_transition === 1 ? "#008607" : "#d90020")}}>{this.state.carList[car].zones[i].entry_speed}</strong> km/h
                                            </p>
                                            <p className={"App_header"} style={{color: "#000000"}}>
                                                {this.props.t("exit")}: <strong style={{fontSize: 26, color: (this.state.carList[car].zones[i].is_clean_transition === 1 ? "#008607" : "#d90020")}}>{this.state.carList[car].zones[i].exit_speed}</strong> km/h
                                            </p>
                                            <p className={"App_header"} style={{color: "#000000"}}>
                                                {this.props.t("avg")}: <strong style={{fontSize: 26, color: (this.state.carList[car].zones[i].is_clean_transition === 1 ? "#008607" : "#d90020")}}>{this.state.carList[car].zones[i].avg_speed}</strong> km/h
                                            </p>
                                        </ReactTooltip>
                                    </div>
                                </td>
                            );
                            break;
                        }
                    }
                    if (!found) {
                        zones.push(
                            <td key={speedTrap + "_not"}>
                                 <span style={{
                                     display: "block",
                                     color: "#FFFFFF",
                                 }}>
                                     ---
                                 </span>
                                <span className={"App_small_header"}>
                                    <strong style={{color: "#009e1a"}}>{this.state.carList[car].clean[speedTrap]}</strong> | <strong style={{color: "#ff1d00"}}>{this.state.carList[car].over_limit[speedTrap]}</strong>
                                </span>
                            </td>
                        );
                    }
                }

                rows.push(
                    <tr key={car} className={"App_white_text onHover"} style={{textAlign: "center"}}>
                        <td>{this.state.carList[car].data.position}</td>
                        <td>{this.state.carList[car].data.lap_cnt}</td>
                        <td>#{this.state.carList[car].livery_number}</td>
                        <td>{this.state.carList[car].short_name}</td>
                        {zones}
                        <td>{(
                            this.state.carList[car].data.current_session_distance &&
                            this.state.carList[car].data.current_session_distance > 0) ? parseFloat(Math.round((parseInt(this.state.carList[car].data.current_session_distance) / 100000) * 100) / 100).toFixed(2) + " km" : "---"

                        }</td>
                        <td>{(
                            this.state.carList[car].data.session_start_fuel_lev &&
                            this.state.carList[car].data.session_start_fuel_lev > 0 &&
                            this.state.carList[car].data.session_start_fuel_lev < 500) ? this.state.carList[car].data.session_start_fuel_lev.toFixed(2) + " L" : "---"
                        }</td>
                        <td>{(
                            this.state.carList[car].data.session_end_fuel_lev &&
                            this.state.carList[car].data.session_end_fuel_lev > 0 &&
                            this.state.carList[car].data.session_end_fuel_lev < 500) ? this.state.carList[car].data.session_end_fuel_lev.toFixed(2) + " L" : "---"
                        }</td>
                    </tr>
                );
            }
        }

        this.setState({
            tableRows: rows,
        }, () => {
            $(".loading").fadeOut();
        });
    }

    render() {
        if (this.state.confirmedOrg) {
            let zones = [];
            for (let i = 0; i < this.state.sessionDetails.speed_control_zone_cnt; i++) {
                zones.push(
                    <th key={"header_zone_" + i} className={"App_header_background hidden-xs"}>Zone {i + 1}</th>
                );
            }

            return (
                <div className={"table-responsive table-scroll-parent App_lapTableContainerStyle"}>
                    <div className="loading">
                        <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                    </div>
                    <div className={"table-scroll-child"}>
                        <table className={"table table-hover table-condensed"}>
                            <thead>
                            <tr style={{textAlign: "center"}}>
                                <th className={"App_header"}>{this.props.t("position").toUpperCase()}</th>
                                <th className={"App_header"}>{this.props.t("lap").toUpperCase()}</th>
                                <th className={"App_header"}>{this.props.t("nr").toUpperCase()}</th>
                                <th className={"App_header"}>{this.props.t("vehicle").toUpperCase()}</th>
                                {zones}
                                <th className={"App_header"}>{this.props.t("distance").toUpperCase()}</th>
                                <th className={"App_header"}>{this.props.t("startFuel").toUpperCase()}</th>
                                <th className={"App_header"}>{this.props.t("endFuel").toUpperCase()}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.tableRows}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        } else {
            return (
                <div/>
            );
        }
    }
}

export default withTranslation("translations")(withCookies(PopoutLiveTimingMiniChallenge));

